// Web-compatible storage utility
// Uses localStorage for web, can be extended for React Native

const Storage = {
  async getItem(key) {
    try {
      const item = localStorage.getItem(key);
      return item;
    } catch (error) {
      console.error('Error getting item from storage:', error);
      return null;
    }
  },

  async setItem(key, value) {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (error) {
      console.error('Error setting item in storage:', error);
      return false;
    }
  },

  async removeItem(key) {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error('Error removing item from storage:', error);
      return false;
    }
  },

  async multiRemove(keys) {
    try {
      keys.forEach(key => {
        localStorage.removeItem(key);
      });
      return true;
    } catch (error) {
      console.error('Error removing multiple items from storage:', error);
      return false;
    }
  }
};

export default Storage;

